import { render } from "./AgeModal.vue?vue&type=template&id=5f7a3a6e"
import script from "./AgeModal.vue?vue&type=script&lang=js"
export * from "./AgeModal.vue?vue&type=script&lang=js"

import "./AgeModal.vue?vue&type=style&index=0&id=5f7a3a6e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__